import { render, staticRenderFns } from "./YearIcon.vue?vue&type=template&id=0864ff47&scoped=true"
import script from "./YearIcon.vue?vue&type=script&lang=js"
export * from "./YearIcon.vue?vue&type=script&lang=js"
import style0 from "./YearIcon.vue?vue&type=style&index=0&id=0864ff47&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864ff47",
  null
  
)

export default component.exports